export default __webpack_public_path__ + "static/media/secret.7c62ceb7.svg";